var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:facebook-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.25 15.6875H19.0625L20.1875 11.1875H16.25V8.9375C16.25 7.77875 16.25 6.6875 18.5 6.6875H20.1875V2.9075C19.8208 2.85913 18.4359 2.75 16.9734 2.75C13.919 2.75 11.75 4.61412 11.75 8.0375V11.1875H8.375V15.6875H11.75V25.25H16.25V15.6875Z",
    fill: "#FFDCA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSvg);
export default __webpack_public_path__ + "static/media/FacebookSVG.e76a39d491a8476777e96f9f7b945b9f.svg";
export { ForwardRef as ReactComponent };